<div class="shell">
  @if (!authenticated() || !navigationReady()) {
    <div class="shell__loading">
      <img class="shell__loading-logo" src="/images/icon-192x192.png" width="112" height="112" alt="AgVantis" />
      @if (authError()) {
        <p>{{ authError() }}</p>
        <button matButton="filled" type="button" (click)="signInAgain()">Sign in again</button>
      } @else {
        <mat-progress-spinner mode="indeterminate" diameter="40" />
        <p>{{ authenticated() ? 'Loading navigation...' : 'Signing in...' }}</p>
      }
    </div>
  } @else {
    @if (authError()) {
      <p class="shell__banner">{{ authError() }}</p>
    }
    @if (navError()) {
      <p class="shell__banner">{{ navError() }}</p>
    }
    <div class="shell__body">
      <aside class="shell__nav" [class.shell__nav--collapsed]="collapsed()">
        <app-sidebar [collapsed]="collapsed()" (collapseToggled)="toggleCollapsed()" />
      </aside>
      <main class="shell__content">
        <router-outlet />
      </main>
    </div>
  }
</div>
